module.exports = __webpack_public_path__ + "img/rwth_tst_en_rgb.f0065490.png";